import { render, staticRenderFns } from "./SiteButton.vue?vue&type=template&id=13c8a20a&scoped=true&"
import script from "./SiteButton.vue?vue&type=script&lang=js&"
export * from "./SiteButton.vue?vue&type=script&lang=js&"
import style0 from "./SiteButton.vue?vue&type=style&index=0&id=13c8a20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c8a20a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SiteButton.vue
// module id = 4
// module chunks = 0